(() => {
  const drawerWidgetSelector = '[data-primebarrel-cart-drawer-widget]';
  const protectionHandle = 'navidium-shipping-protection';
  let refreshPromise;
  let lastRefresh = 0;

  const readVariants = () => {
    try {
      const variants = JSON.parse(localStorage.getItem('nvdProductVariants'));
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  };

  const widgetNeedsRepair = () => [...document.querySelectorAll(drawerWidgetSelector)]
    .some((widget) => /NaN/i.test(widget.textContent || ''));

  const refreshNavidiumVariants = () => {
    if (refreshPromise) return refreshPromise;

    refreshPromise = fetch(`/products/${protectionHandle}.js`, {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Protection product returned ${response.status}`);
        return response.json();
      })
      .then((product) => {
        const variants = (product.variants || [])
          .map((variant) => ({ price: Number(variant.price) / 100, id: variant.id }))
          .filter((variant) => Number.isFinite(variant.price) && variant.id);

        if (!variants.length) throw new Error('Protection product has no usable variants');
        localStorage.setItem('nvdProductVariants', JSON.stringify(variants));
        localStorage.removeItem('nvdProduct');
        lastRefresh = Date.now();

        /* Navidium's React widget reads nvdCart synchronously during a rerender.
           Populate that cache first so an empty or first-visit cart cannot
           produce a null.items exception. */
        return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      })
      .then((response) => {
        if (!response || !response.ok) throw new Error('Cart cache refresh failed');
        return response.json();
      })
      .then((cart) => {
        if (!cart || !Array.isArray(cart.items)) throw new Error('Cart response is invalid');
        localStorage.setItem('nvdCart', JSON.stringify(cart));

        /* Navidium 511 listens for this event, refetches the cart and rerenders
           its React widget using the repaired variant-price cache. */
        window.dispatchEvent(new CustomEvent('nvd_cart_changed', {
          detail: { source: 'primebarrel-variant-cache-repair' }
        }));
      })
      .catch((error) => {
        console.warn('Navidium protection variants could not be refreshed.', error);
      })
      .finally(() => {
        refreshPromise = null;
      });

    return refreshPromise;
  };

  const repairIfNeeded = () => {
    if (!widgetNeedsRepair()) return;
    if (Date.now() - lastRefresh < 2000) return;

    const variants = readVariants();
    if (!variants.length || widgetNeedsRepair()) refreshNavidiumVariants();
  };

  const start = () => {
    /* Prime the cache before a customer opens an AJAX cart drawer. */
    refreshNavidiumVariants();

    const observer = new MutationObserver(() => {
      window.setTimeout(repairIfNeeded, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
